import { render, staticRenderFns } from "./ArchivePc.vue?vue&type=template&id=8655bc5a&scoped=true&"
import script from "./ArchivePc.vue?vue&type=script&lang=js&"
export * from "./ArchivePc.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePc.vue?vue&type=style&index=0&id=8655bc5a&prod&lang=css&"
import style1 from "./ArchivePc.vue?vue&type=style&index=1&id=8655bc5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8655bc5a",
  null
  
)

export default component.exports